var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UiButton", {
    staticClass: "flex-1 h-9",
    attrs: {
      variant: "secondary",
      size: "no",
      buttonClasses: "h-9 px-2.5 text-sm min-w-40",
      disabled: _vm.disabled,
      buttonText: _vm.buttonText,
      processing: _vm.processing,
    },
    on: {
      click: function ($event) {
        return _vm.$emit("click")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }